import React from "react";
import Icon from "../ui/Icon";

export default function TableSwitchModal({
  open,
  onClose,
  tables,
  currentTableId,
  sessionId, // kept for compatibility (not used)
  onSwitchTable,
  switching,
}) {
  if (!open) return null;

  const stripHtml = (html) =>
    html
      ?.replace(/<[^>]+>/g, "")
      .replace(/\r/g, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim() || "";

  return (
    <div
      className="jt-modalOverlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={onClose}
    >
      <div
        className="jt-sheet jt-sheetTables"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="jt-sheetHead">
          <div className="jt-sheetTitle">
            <span className="jt-sheetIcon">
              <Icon name="grid" />
            </span>
            Session Tables
          </div>
          <button
            className="jt-sheetClose"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon name="close" />
          </button>
        </div>

        <div className="jt-sheetBody jt-tablesBody">
          {!tables || tables.length === 0 ? (
            <div className="jt-tablesEmpty">No tables available</div>
          ) : (
            tables.map((t) => {
              const isCurrent =
                String(t._id || t.id) === String(currentTableId);
              const isFull = Boolean(t.isFull);
              const isUserInThisTable = Boolean(t.isUserInTable) || isCurrent;

              const isQueued = Boolean(t.isUserQueued);
              const actionLabel = isQueued
                ? t.queuePosition
                  ? `Waiting (${t.queuePosition})`
                  : "Waiting"
                : isFull
                  ? "Join queue"
                  : "Switch";

              return (
                <div
                  key={t._id || t.id}
                  className={`jt-tableCard ${isCurrent ? "current" : ""}`}
                >
                  <div className="jt-tableCardHead">
                    <div className="jt-tableCardIcon">
                      {t.sponcer?.image || t.tableIcon ? (
                        <img src={t.sponcer?.image || t.tableIcon} alt="" />
                      ) : (
                        <span>🌲</span>
                      )}
                    </div>
                    <div className="jt-tableCardInfo">
                      <div className="jt-tableCardName">
                        {t.tableName || "Table"}
                      </div>
                      <div className="jt-tableCardMeta">
                        {t.currentOccupancy || 0}/{t.capacity || 8} seated •{" "}
                        {isCurrent ? "Current" : isFull ? "Full" : "Available"}
                      </div>
                    </div>

                    {isUserInThisTable ? (
                      <div className="jt-currentBadge">Already joined</div>
                    ) : (
                      <button
                        className={`jt-switchBtn ${isFull ? "full" : ""}`}
                        onClick={() => onSwitchTable(t)}
                        disabled={switching || isQueued}
                        type="button"
                      >
                        {switching ? "..." : actionLabel}
                      </button>
                    )}
                  </div>

                  {t.agenda && (
                    <details className="jt-tableAgenda">
                      <summary>Agenda</summary>
                      <div className="jt-agendaContent">
                        {stripHtml(t.agenda)}
                      </div>
                    </details>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
